(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/game-list-new/assets/javascripts/hooks/use-get-game-url.js') >= 0) return;  svs.modules.push('/components/marketplace/game-list-new/assets/javascripts/hooks/use-get-game-url.js');

'use strict';

const getGameAriaLabel = svs.components.marketplace.helpers.games.getGameAriaLabel;
const _svs$components$marke = svs.components.marketplace.helpers,
  getTeamUrl = _svs$components$marke.getTeamUrl,
  getRetailUrl = _svs$components$marke.getRetailUrl;
const useGetGameUrl = function (game) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const groupId = options.groupId,
    groupName = options.groupName,
    _options$isRetail = options.isRetail,
    isRetail = _options$isRetail === void 0 ? false : _options$isRetail,
    _options$isListing = options.isListing,
    isListing = _options$isListing === void 0 ? false : _options$isListing,
    _options$fromTeamList = options.fromTeamList,
    fromTeamList = _options$fromTeamList === void 0 ? false : _options$fromTeamList,
    _options$gameLinkSear = options.gameLinkSearch,
    gameLinkSearch = _options$gameLinkSear === void 0 ? '' : _options$gameLinkSear,
    _options$location = options.location,
    location = _options$location === void 0 ? null : _options$location;
  const isCurrentUserAuthenticated = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  if (!game || !game.activatedDrawId || !game.containerId) {
    return {
      url: null,
      ariaLabel: null
    };
  }
  const activatedDrawId = game.activatedDrawId,
    containerId = game.containerId;

  const linkTo = isRetail ? getRetailUrl(groupId, groupName, 'spel', containerId, activatedDrawId) : getTeamUrl(groupId, groupName, 'spel', containerId, activatedDrawId);
  let queryString = '';
  if (gameLinkSearch) {
    queryString = "?".concat(gameLinkSearch);
  } else if (location && location.search) {
    queryString = "?".concat(location.search);
  }
  const routeUrl = fromTeamList ? "".concat(linkTo).concat(queryString) : linkTo;
  const finalUrl = routeUrl;

  const ariaLabel = getGameAriaLabel({
    game,
    groupId,
    isCurrentUserAuthenticated,
    isListing,
    isRetail
  });
  return {
    url: finalUrl,
    ariaLabel
  };
};
setGlobal('svs.components.marketplace.gameListNew.hooks.useGetGameUrl', useGetGameUrl);

 })(window);